import { useEffect, useState }  from "react";
import ApiModels from '../../api/models';
import { useDispatch, useSelector } from "react-redux";
import { models as actionsModels, log as actionsLog  } from "../../store/actions";

const { setSelectedModel, getModels } = actionsModels;

const { addToLog } = actionsLog;

const SimilarGroup = () => {

    let dispatch = useDispatch();

    let selectedMake = useSelector(store => store.makes.selectedMake);
    let selectedModel = useSelector(store => store.models.selectedModel);

    const [ trigger, setTrigger ] = useState(0);
    const [ canSave, setCanSave ] = useState(false);
    const [ selectedGroup, setSelectedGroup ] = useState(selectedModel.similarGroup);

    const groups = [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'J',
        'K',
        'L',
        'M',
        'O',
        'P',
        'R',
        'S',
        'T',
        'V',
        'X',
        'Y',
        'U',
        'W',
        'Q',
        'Z'
    ];

    useEffect(() => {
        setCanSave(selectedGroup != selectedModel.similarGroup);
    }, [selectedGroup, trigger]);

    useEffect(() => {
        setSelectedGroup(selectedModel.similarGroup);
        setCanSave(selectedGroup != selectedModel.similarGroup);
    }, [selectedModel]);

    const selectSimilarGroup = e => {
        const group = e.target.value;
        setSelectedGroup(group);
        setCanSave(selectedGroup != selectedModel.similarGroup);
    };

    const save = () => {

        let proceed = window.confirm(`Update similar group for model: ${selectedModel.name}?`);
        if (proceed) {
            ApiModels.setSimilarGroup(selectedModel.id, selectedGroup).then(resp => {
                dispatch(addToLog(resp));
                dispatch(getModels(selectedMake.id));
                dispatch(setSelectedModel({ ...selectedModel, similarGroup: selectedGroup }));
                setTrigger(new Date());
            });
        }

    }

    const buttonClass = (additional) => {
        return `${additional} border rounded ${canSave ? 
            'border-blue-700 bg-blue-800 cursor-pointer hover:bg-blue-700 hover:border-blue-800 text-white' : 
            'border-gray-700 bg-gray-800 cursor-not-allowed'}`;
    }

    return (
        <div>
            {
                selectedModel && selectedModel.id > 0 ? 
                <div className="border border-gray-700 mb-2">
                <div className="text-lg p-2 bg-gray-900">
                    Similar group for { selectedModel.id > -1 ? "for " + selectedModel.name : "" }
                </div>
                <div className="flex flex-1 flex-wrap p-2">
                    <select value={selectedGroup} onChange={selectSimilarGroup} className="p-2 my-2 bg-gray-800 border border-gray-700 w-full">
                        {groups.map(group => {
                            return <option value={group} key={group}>{group}</option>
                        })}
                    </select>
                </div>
                <div className="p-2 flex">
                    <button className={buttonClass('ml-auto p-2')} disabled={!canSave} onClick={save}>Save</button>
                </div>
            </div>
            : 
            <></>
            }
        </div>
    );
}

export default SimilarGroup;